import { ProviderType } from 'domains/models/calendar/providerType';
import { ResponseStatus } from 'domains/models/event/responseStatus';
import { Status } from 'domains/models/event/status';
import { DateTime } from 'infras/datetime';

export const horizontalRulerWidth = 50;
export const APPEND_PAGES_COUNT = 4;

export enum CalendarMode {
  Event = 0,
  Slot = 1,
  Booking = 2,
}

export interface ShowRange {
  month?: 1;
  day?: 1 | 2 | 3 | 4 | 5 | 6 | 7;
}
export type CalendarWeekDay = 0 | 1 | 2 | 3 | 4 | 5 | 6;

export interface Position {
  x: number;
  y: number;
}

export interface Errors {
  code: ErrorCode;
  message?: string;
}

export enum ErrorCode {
  MAX_NUMBER_OF_SLOTS_EXCEEDED = 1,
  MAX_NUMBER_OF_SLOT_GROUPS_EXCEEDED = 2,
}

export enum CalendarSource {
  Jicoo = 1,
  Integration = 2,
}

export interface Availability {
  startedAt: string;
  endedAt: string;
  timeZone: string;
  color: string;
  isAllDay: boolean;
}

export enum ScheduleType {
  Event = 0,
  Availability = 10,
}

export interface Schedule {
  uid: string;
  userId: string;
  calendarId: string;
  eventId: string;
  scheduleType: ScheduleType;
  name: string | null;
  startedAt: string;
  endedAt: string;
  timeZone: string;
  transparency?: number;
  color: string;
  isAllDay: boolean;
  url: string | null;
  status: Status;
  responseStatus: ResponseStatus;
  description: string | null;
  providerType: ProviderType;
  calendarSource: CalendarSource;
  address: string | null;
  isRecurringEvent: boolean;
  behavior: Behavior;
  customData?: any;
}

export interface Frame {
  x: number;
  xSpan: number;
  y: number;
  ySpan: number;
  date: DateTime;
}

export interface EventListItem {
  scheduleType: ScheduleType;
  uid: string;
  layoutId: string;
  calendarId: string;
  eventId: string;
  isDraggable: boolean;
  name: string;
  isAllDay: boolean;
  x: number;
  xRatio?: number;
  xSpan?: number;
  xOriginalSpan?: number; // 週またぎなどで分割されたEventで使用
  xSpanRatio?: number;
  xMargin?: number;
  y: number;
  ySpan: number;
  yPosition?: number;
  color: string;
  userId: string;
  url: string | null;
  status: Status;
  responseStatus: ResponseStatus;
  providerType: ProviderType;
  calendarSource: CalendarSource;
  description: string | null;
  address: string | null;
  isRecurringEvent: boolean;
  behavior: Behavior;
  startedAt: DateTime;
  endedAt: DateTime;
  customData?: {
    capacity?: {
      label: string;
      isFull: boolean;
      remaining: number;
    };
    guestUsers?: any;
  };
}

export interface MergeableEventListItem extends EventListItem {
  mergedEvents?: EventListItem[];
}

export enum SlotViewType {
  SlotAndGroup = 1,
  Slot = 2,
  Group = 3,
}

export interface Slot {
  startedAt: DateTime;
  endedAt: DateTime;
}

export interface SelectedGroup {
  x: number;
  xSpan: number;
  y: number;
  ySpan: number;
  startedAt: DateTime;
  endedAt: DateTime;
  isAllDay: boolean;
}

export interface SelectedSlot {
  x: number;
  y: number;
  ySpan: number;
  date: DateTime;
  isAllDay: boolean;
}

// export interface CreatingEvent {
//   startedAt: DateTime;
//   endedAt: DateTime;
//   color: string;
//   name: string;
//   isAllDay: boolean;
//   x?: number;
//   y?: number;
//   ySpan?: number;
// }

export const slotDurationList = [
  // 5,
  // 10,
  15,
  // 20,
  30,
  45,
  60,
  90,
  120,
  150,
  180,
  240,
];

export enum TimeFormat {
  Time24 = '24',
  Time12 = '12',
}

export enum Behavior {
  Event = 0,
  Work = 1,
}
